import React, { Component } from "react";
import * as ReactDOM from "react-dom";

import logo from './logo.svg';
import './App.css';
import './About.css'

class Item extends Component {
  shouldComponentUpdate() {
    return false;
  }
  render() {

    console.log("Videos");
  return (
   
    <div className="App">
   
      <header className="App-header">




        <p className="meme">For the past year we have been focused on using data science to provide solutions and services to give communities the independence they deserve.
          We supplement this goal by working with like-minded clients that are looking to drive change.
        </p>
      
        
      
        
        
      </header>
    </div>
  );
}

}
export default Item;
